import React from "react";
import Modal from "../Modal";
import images from "../../../../utilities/images/images";
import "./ResumeModal.css";

const ResumeModal = ({ isOpen, onClose, onSubmit, onResume, resumeLabel }) => {
  const label = resumeLabel || "Resume Test";
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="38rem"
      height="22rem"
      closeAboveModal
      stackClassName="resume-modal-stack"
    >
      <div className="resume-wrapper">

        <div className="resume-icon">
          <img src={images.resume_practice_icon} alt="resume" />
        </div>

        <h2 className="resume-title">{label}</h2>

        <p className="resume-subtitle">
          Are you sure you want to Resume?
        </p>

        <div className="resume-buttons">

          <button
            className="resume-submit-btn"
            onClick={onSubmit}
          >
            Submit
          </button>

          <button
            className="resume-confirm-btn"
            onClick={onResume}
          >
            {label}
          </button>

        </div>
      </div>
    </Modal>
  );
};

export default ResumeModal;